<mat-card class="pb-3">
  <mat-card-header>
    <mat-card-title>Solutions</mat-card-title>
    <a mat-button (click)="onCreateSolution()" color="primary">
      Add Solution
    </a>
  </mat-card-header>

  <mat-card-content>
    <mat-accordion>

      <ng-template ngFor let-solution [ngForOf]="solutions">
        <mat-expansion-panel [expanded]="false">
          <mat-expansion-panel-header>
            <mat-panel-title>{{solution.title}}</mat-panel-title>
            <button mat-button color="primary" (click)="onEditSolution(solution)">
              Manage
            </button>
          </mat-expansion-panel-header>
          <h2>Correct Answer:</h2>
          <app-ck-editor
            [(ngModel)]="solution.correctAnswer"
            [inline]="true"
            [config]="{extraPlugins: 'mathjax',
               mathJaxLib: '//cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.0/MathJax.js?config=TeX-AMS_HTML'
               }"
            [readonly]="true"
          >
          </app-ck-editor>

          <h2>Wrong Answers:</h2>
          <ng-template ngFor let-answer [ngForOf]="parseWrongAnswer(solution)">
            <app-ck-editor [readonlyData]=answer
                           [inline]="true"
                           [config]="{extraPlugins: 'mathjax',
               mathJaxLib: '//cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.0/MathJax.js?config=TeX-AMS_HTML'
               }"
                           [readonly]="true"
            >
            </app-ck-editor>

          </ng-template>

        </mat-expansion-panel>
      </ng-template>
    </mat-accordion>
  </mat-card-content>
</mat-card>
